import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { StorageService } from 'app/modules/auth/services/storage.service';
import { CONSTANTS } from 'app/_helpers/constants';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvertisingGuard implements CanActivate {
  constructor(
    private storageService: StorageService,
    private http: HttpClient,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
  const user = this.storageService.getUserInfo();
  const clubId = user?.activeClubId;
  const allRoles = this.storageService.getRoles();

  if (!user || !clubId) {
    this.router.navigate(['/unauthorized']);
    return of(false);
  }

  return this.getPublicAdvertisingVisibility(clubId).pipe(
    switchMap((response) => {
      const isShowAdvertising = response.is_show_advertising;

      if (isShowAdvertising) {
        return of(true); // autorisé pour tous
      }

      const hasValidRole = user.roles?.some((roleName: string) => {
        const role = allRoles?.find((r) => r.name === roleName);
        return role?.level >= CONSTANTS.LEVEL_COMMUNITY_MANAGER;
      });

      if (!hasValidRole) {
        this.router.navigate(['/unauthorized']);
        return of(false);
      }

      return of(true);
    }),
    catchError((err) => {
      console.error('Erreur dans AdvertisingGuard:', err);
      this.router.navigate(['/unauthorized']);
      return of(false);
    })
  );
}


  private getPublicAdvertisingVisibility(clubId: string): Observable<{ is_show_advertising: boolean }> {
    const url = `${environment.apiNest_2}/api/v1/club/${clubId}/public-advertising-visibility`;
    return this.http.get<{ is_show_advertising: boolean }>(url);
  }
}
